import React from 'react';
import withApolloClient from '~/hocs/withApolloClient';
import withState from '~/hocs/withState';
import { withRouter } from 'next/router';
import { initStore } from '~/state/store';
import { operations } from '~/state/pageData';
import moment from 'moment';

import GraphQLScheduleContainer from '~/containers/GraphQLScheduleContainer/GraphQLScheduleContainer';

interface Props {
  leagueSlug: string;
  group: string;
  router: {
    pathname: string,
    query: any,
    asPath: string,
  };
}

class Events extends React.Component<Props> {
  static async getInitialProps(props) {
    props.store.dispatch(operations.setRouteParams(props.query));

    return {
      leagueSlug: props.leagueSlug,
      group: props.query.group,
    };
  }

  render() {
    const { router, leagueSlug } = this.props;
    const date = router.query.group ? router.query.group : moment().format('YYYY-MM');
    return <GraphQLScheduleContainer league={leagueSlug} selected={date} />;
  }
}

const mapStateToProps = state => ({
  pageData: state.pageData,
});

export default withState(initStore, mapStateToProps)(withApolloClient(withRouter(Events)));
